// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"9a632212","648":"c4ee06d0","684":"ff94a5dd","961":"116b982b"}[chunkId] + ".chunk.js";
};